<template>
<div class="chapter">
<div class="inner_page">
      ﻿





<title>Eddies Bastard</title>
<link href="page-template.xpgt" rel="stylesheet" type="application/vnd.adobe-page-template+xml"/>
<link href="pdlmsr.css" rel="stylesheet" type="text/css"/>
<meta content="text/html; charset=UTF-8"/>
<div class="dedicationPage" id="ded01">
<a id="page05">
<p class="dedicationText">For</p>
<p class="dedicationText"> McKinley Patrick Miller</p>
<p class="dedicationText"> and</p>
<p class="dedicationText"> In Memory of Dale</p>
</a><a id="page06">
</a></div>
<a id="page06">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eddiesbastard_ded01.vue?613b839f